import BundlePackageGroup from "./BundlePackageGroup";
import styles from "./BundlePackageGroup.module.css";
import { BundlePackageData } from "../../interfaces/BundlePackageGroup";

export default function BundlePackageGroupContainer({
  data,
}: {
  data: BundlePackageData[];
}) {
  return (
    <div
      className={`vas-d-flex vas-gap-3 vas-w-100 ${styles.card_holder}`}
      style={{ border: "0px" }}
    >
      {data &&
        data.map((item, idx) => <BundlePackageGroup data={item} key={idx} />)}
    </div>
  );
}
